import { ResourceType } from 'libs.library_manager';
export const CONSENT_TEMPLATE_DATA_MISSING = 'CONSENT_TEMPLATE_DATA_MISSING';
export class ConsentTemplateDataMissingError extends Error {
    constructor() {
        super('Consent template configuration data is missing.');
        this.code = CONSENT_TEMPLATE_DATA_MISSING;
        this.name = 'ConsentTemplateDataMissingError';
    }
}
const readBlobAsDataUrl = (blob) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(new Error('Failed to read PDF'));
    reader.readAsDataURL(blob);
});
/** GET CONSENT_TEMPLATE JSON only. Fail closed when `data` is null — never treat that as empty config. */
export const fetchConsentTemplateJson = async (get, documentId) => {
    const { data: templateResponse } = await get(`v1/${ResourceType.CONSENT_TEMPLATE}/${documentId}`);
    const template = templateResponse.data;
    if (!template || template.data === null || template.data === undefined) {
        throw new ConsentTemplateDataMissingError();
    }
    return template;
};
/** GET CONSENT_ASSET blob URL then the PDF itself. Call only when Locate (or View source) needs the file. */
export const fetchConsentAssetDataUrl = async (get, assetId) => {
    const { data: assetResponse } = await get(`v1/${ResourceType.CONSENT_ASSET}/${assetId}`, {
        params: { withUrl: true },
    });
    const pdfUrl = assetResponse.data.blobUrl;
    if (!pdfUrl) {
        throw new Error('PDF not found for this template.');
    }
    const pdfResponse = await fetch(pdfUrl);
    if (!pdfResponse.ok) {
        throw new Error('PDF not found for this template.');
    }
    return readBlobAsDataUrl(await pdfResponse.blob());
};
